export const MOBILE_MAX_WIDTH = 768
export const LOW_DISPLAY_WIDTH = 1280

export const DEVICES = {
  mobile: `@media (max-width: ${MOBILE_MAX_WIDTH}px)`,
  pc: `@media (min-width: ${MOBILE_MAX_WIDTH + 1}px)`,
  low: `@media (max-width: ${LOW_DISPLAY_WIDTH}px)`,
}
